import { useTranslation } from "react-i18next";

import { CardContainer } from "@/components/card-container";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { APP_NAME, useTenantDisplayName } from "@/features/branding";

import { DisplayMode } from "./tax-preview.types";

interface TaxPreviewProps {
  mode: DisplayMode;
  isOpen?: boolean;
  onClose?: () => void;
  onContinue: () => void;
}

export const TaxPreview = ({
  mode,
  isOpen = true,
  onClose,
  onContinue,
}: TaxPreviewProps) => {
  const { t } = useTranslation();
  const clientName = useTenantDisplayName() ?? APP_NAME;

  const renderContent = () => {
    return (
      <>
        <p data-test-id="tax-preview-p1" className="leading-relaxed">
          {t("tax_onboarding_intro_description_p1")}
        </p>
        <p data-test-id="tax-preview-p2" className="leading-relaxed">
          {t("tax_onboarding_intro_description_p2")}
        </p>
        <p data-test-id="tax-preview-p3" className="leading-relaxed">
          {t("tax_onboarding_intro_description_p3")}
        </p>
        <p data-test-id="tax-preview-p4" className="leading-relaxed">
          {t("tax_onboarding_intro_description_p4")}
        </p>
      </>
    );
  };

  if (mode === DisplayMode.fullpage) {
    return (
      <CardContainer>
        <CardContainer.Content>
          <h6 className="text-xl font-semibold mb-4">{t("tax_submit")}</h6>
          {renderContent()}
        </CardContainer.Content>
        <div className="flex justify-end gap-4 mt-4">
          <Button
            data-test-id="tax-preview-primary-button"
            onClick={onContinue}
          >
            {t("continue_text")}
          </Button>
        </div>
      </CardContainer>
    );
  }

  /* TODO: Double check this implementation, there is no state for open/close */
  return (
    <Dialog
      aria-labelledby="tax-preview-title"
      aria-describedby="tax-preview-description"
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose?.();
        }
      }}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {t("auth_welcomeToApp", {
              client: clientName,
            })}
          </DialogTitle>
        </DialogHeader>

        {renderContent()}

        <div className="flex justify-end gap-4 mt-4">
          {onClose && (
            <Button
              data-test-id="tax-preview-secondary-button"
              variant="outline"
              onClick={onClose}
            >
              {t("skip")}
            </Button>
          )}
          <Button
            data-test-id="tax-preview-primary-button"
            onClick={onContinue}
          >
            {t("continue_text")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
